import React from 'react';
import {
  AlertTriangle,
  BarChart3,
  Binary,
  Bot,
  Box,
  Cloud,
  Container,
  Code,
  Code2,
  Columns3,
  Database,
  ExternalLink,
  File,
  FileText,
  FolderClosed,
  FolderOpen,
  FolderTree,
  HardDrive,
  Hash,
  Key,
  Layers,
  LayoutDashboard,
  LayoutGrid,
  Link,
  List,
  Lock,
  MessageSquare,
  Network,
  Package,
  Shield,
  Table,
  User,
  UserCog,
  Users,
  Timer,
  Waypoints,
  Zap,
  Plus,
} from 'lucide-react';

export const DEFAULT_ICON_MAP: Record<string, React.ElementType> = {
  'connection': Network,
  'folder': FolderClosed,
  'folder-open': FolderOpen,
  'table': Table,
  'view': FileText,
  'stored-procedure': Code,
  'function': Code2,
  'database': Database,
  'message': MessageSquare,
  'error': AlertTriangle,
  'default': FolderClosed,
  // Table subfolders
  'columns-folder': Columns3,
  'keys-folder': Key,
  'constraints-folder': Lock,
  'triggers-folder': Zap,
  'indexes-folder': List,
  'statistics-folder': BarChart3,
  'partitions-folder': Layers,
  // Column node
  'column': Columns3,
  // Table subfolder leaf nodes
  'key': Key,
  'constraint': Lock,
  'index': List,
  'trigger': Zap,
  'statistic': BarChart3,
  'partition': Table,
  // Oracle-specific folders and objects
  'packages-folder': Package,
  'sequences-folder': Hash,
  'synonyms-folder': Link,
  'db-links-folder': ExternalLink,
  'materialized-views-folder': Layers,
  'types-folder': Box,
  'package': Package,
  'sequence': Hash,
  'synonym': Link,
  'db-link': ExternalLink,
  'materialized-view': Layers,
  'type': Box,
  'directories-folder': HardDrive,
  'directory': HardDrive,
  // SQL Server user-defined types (Programmability -> Types)
  'user-types-folder': Box,
  'table-types-folder': Table,
  'alias-types-folder': Box,
  'clr-types-folder': Binary,
  'table-type': Table,
  'alias-type': Box,
  'clr-type': Binary,
  // Kusto-specific folders and objects
  'external-tables-folder': ExternalLink,
  'external-table': ExternalLink,
  // Property graphs (Oracle 23ai / PostgreSQL 19)
  'property-graphs-folder': Waypoints,
  'property-graph': Waypoints,
  // Security folders (server-level)
  'server-security-folder': Shield,
  'logins-folder': UserCog,
  'server-roles-folder': Users,
  // PostgreSQL roles folder
  'pg-roles-folder': Users,
  'login-roles-folder': UserCog,
  'group-roles-folder': Users,
  // Security folders (database-level)
  'database-security-folder': Shield,
  'users-folder': User,
  'database-roles-folder': Users,
  'schemas-folder': FolderClosed,
  // Schema-first grouping
  'schema-container-folder': FolderTree,
  // Security objects
  'login': UserCog,
  'server-role': Users,
  'database-user': User,
  'database-role': Users,
  'schema': FolderClosed,
  'login-role': UserCog,
  'group-role': Users,
  // Oracle security objects
  'oracle-user': UserCog,
  'oracle-role': Users,
  'oracle-roles-folder': Users,
  // SQL Server Agent folders
  'agent-jobs-folder': Bot,
  'agent-jobs-subfolder': FolderClosed,
  'agent-job': Timer,
  'agent-operator': User,
  'agent-alert': AlertTriangle,
  'agent-proxy': Shield,
  // S23 — conditional "Dashboards" root node + its children
  'dashboards-root': LayoutDashboard,
  'dashboard': LayoutGrid,
  // Azure Storage (spec §5.1)
  'storage-service-folder': Cloud,
  'storage-container': Container,
  'storage-table': Table,
  'storage-queue': MessageSquare,
  'storage-share': HardDrive,
  'storage-file': File, // UI review F14: a single-file / single-blob attachment's root (`node.icon`)
  // Round B U30: "Create container…" / "Create share…" / "Open share by name…" are actions, not items — a plus, never a bolt.
  'storage-action': Plus,
  'pinned-storage': Container,
};
